// src/components/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

export default function LoginPage() {
  const { login, authError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    await login(email.trim(), password);
    setLoading(false);
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0f1117',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
    }}>
      <div style={{
        background: '#1a1d27', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 14, padding: '40px 36px', width: 360,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        {/* Logo / Brand */}
        <div style={{ textAlign: 'center', marginBottom: 30 }}>
          <div style={{
            fontSize: 28, fontWeight: 900, letterSpacing: '-0.5px',
            background: 'linear-gradient(135deg, #4f8ef7, #a78bfa)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            marginBottom: 4,
          }}>AdFlowz</div>
          <div style={{ color: '#888', fontSize: 13 }}>Paid Media Onboarding Tracker</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
              placeholder="you@company.com"
              style={{
                width: '100%', padding: '10px 12px', fontSize: 14,
                background: '#0f1117', border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 8, color: '#f0f0f0', boxSizing: 'border-box',
                outline: 'none',
              }}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{
                width: '100%', padding: '10px 12px', fontSize: 14,
                background: '#0f1117', border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 8, color: '#f0f0f0', boxSizing: 'border-box',
                outline: 'none',
              }}
            />
          </div>

          {authError && (
            <div style={{
              background: '#3a1212', border: '1px solid #7a2020',
              borderRadius: 8, padding: '10px 12px', marginBottom: 16,
              color: '#f87171', fontSize: 13,
            }}>
              {authError}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '11px', fontSize: 14, fontWeight: 700,
              background: loading ? '#3a4a7a' : 'linear-gradient(135deg, #4f8ef7, #6366f1)',
              border: 'none', borderRadius: 8, color: '#fff',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'opacity 0.2s',
            }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: 24, textAlign: 'center', color: '#555', fontSize: 12 }}>
          Access restricted to authorized team members only.
        </div>
      </div>
    </div>
  );
}
